import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeesComponent } from './fees.component';
import { DefinitionEditorComponent } from './definition-editor/definition-editor.component';
import { ApplicationComponent } from './application/application.component';
import { SharedModule } from '../../../shared/shared.module';
import { UIModule } from '../../../routes/ui/ui.module';
import { ApplicationEditorComponent } from './application/application-editor/application-editor.component';
import { PopupsModule } from '../../../routes/popups/popups.module';
import { JvUiModule } from '../../../../../projects/jv-ui/src/lib/jv-ui.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    UIModule,
    PopupsModule,
    JvUiModule
  ],
  declarations: [
    FeesComponent,
    DefinitionEditorComponent,
    ApplicationComponent,
    ApplicationEditorComponent
  ],

  entryComponents: [
    DefinitionEditorComponent,
    ApplicationEditorComponent
  ]
})
export class FeesModule { }
